var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.49,26.106h-5.467v12.998H7.203V2.896h14.287c8.871,0,13.307,5.003,13.307,11.656,0,5.983-4.075,11.553-13.307,11.553Zm-.671-7.014c3.507,0,5.003-1.754,5.003-4.539s-1.496-4.539-5.003-4.539h-4.796v9.078h4.796Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorParking);
export default __webpack_public_path__ + "static/media/indoor-parking.f80091d2d32db361dd29a207e6400919.svg";
export { ForwardRef as ReactComponent };